// extracted by mini-css-extract-plugin
export var divider = "MobileNav-module--divider--cae1e";
export var dropdown = "MobileNav-module--dropdown--29030";
export var dropdownWrap = "MobileNav-module--dropdownWrap--ec780";
export var label = "MobileNav-module--label--7277a";
export var labelText = "MobileNav-module--labelText--3b33f";
export var mobileNav = "MobileNav-module--mobileNav--725ed";
export var select = "MobileNav-module--select--4302d";